import { useEffect, useState } from "react";
import { Generico } from "../../components/Generico";
import { Interesado } from "../../models/riesgo/Interesado"
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { useForm } from "react-hook-form";
import { InputComponent } from "../../components/InputComponent";
import { confirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import { Panel } from "primereact/panel";
import { Button } from "primereact/button";
import { Criterios } from "./Criterios";

export const Actor = ({ generic, permss, toast, riesgo, id, catalogo, funcionalidades }) => {

    const omodel = new Interesado();
    const matrizSrv = new MonitoreoService();
    const { accionesTbl } = Generico();
    const defaultValues = generic.default(omodel.model);
    const [registros, setRegistros] = useState(null);
    const [item, setItem] = useState(null);
    const [dialogCriterio, setDialogCriterio] = useState(false);
    const [dialogActor, setDialogActor] = useState(false);
    const [lista, setLista] = useState(null);
    const [titulo, setTitulo] = useState(null);
    const [tipo, setTipo] = useState(null);
    const [load, setLoad] = useState(false);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    const { table, setLoading, setTotalRecords, lazyParams, inDrop } =
        InputComponent({ registers: registros, omodel, generic, errors, control, permss, id: getValues('id') });

    useEffect(() => {
        setLista(catalogo);
        loadLazyData();
    }, [lazyParams]);

    const loadLazyData = () => {
        setLoading(true);
        const _lazyParams = lazyParams;
        _lazyParams.idp = id;
        matrizSrv.listado('matriz-riesgo-actor/lista', { lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            setTotalRecords(res.data.total);
            setRegistros(res.data.registros);
            setLoading(false);
        });
    }

    const openNew = () => {
        reset(defaultValues);
        setDialogActor(true);
    }

    const onSubmit = (data) => {
        data.idp = id;
        setLoad(true);
        if (getValues('id') == null) {
            matrizSrv.nuevo(data, 'matriz-riesgo-actor/nuevo').then(res => {
                generic.funcSuccess(res, toast);
                setDialogActor(false);
                loadLazyData();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            }).finally(() => {
                setLoad(false);
            });
        }
        else {
            matrizSrv.editar(data, 'matriz-riesgo-actor/editar').then(res => {
                generic.funcSuccess(res, toast);
                setDialogActor(false);
                loadLazyData();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            }).finally(() => {
                setLoad(false);
            });
        }
    }

    const editar = () => {
        matrizSrv.consultar(`${item?.id}/${id}`, 'matriz-riesgo-actor/consulta').then(res => {
            const _riesgo = res.data;
            reset(generic.renewValues(_riesgo, omodel.model));
            setDialogActor(true);
        });
    }

    const confirmDelete = () => {
        confirmDialog({
            group: 'eliminar-riesgo',
            message: '¿Está seguro de eliminar la información?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => eliminar()
        });
    }

    const eliminar = () => {
        matrizSrv.eliminar(`${item?.id}/${id}`, 'matriz-riesgo-actor/eliminar').then(res => {
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    const itemsMenu = () => {
        const items = [];
        if (permss?.actualizar)
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => { editar() } });
        if (permss?.eliminar)
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { confirmDelete() } });

        return [{ label: 'Opciones', items: items }];
    }

    const customDialogHeader = () => {
        return (
            <div>
                <i className="pi pi-user-edit icon-header" />
                <span className="title-header">
                    {getValues('id') == null ? " Nuevo " : " Editar "}
                </span>
            </div>
        );
    }

    const headerTemplate = (options) => {
        return (
            <div className={options.className}>
                <div className="flex align-items-center gap-2">
                    {permss?.crear && <Button icon="pi pi-plus" className="p-button-rounded p-button-success mr-2" type="button" onClick={openNew} />}
                    <span className="font-bold">PARTES INTERESADAS (ACTORES/ASOCIADOS DE NEGOCIOS) </span>
                </div>
            </div>
        );
    }

    const seleccion = (info, listado) => {
        const _lista = lista;
        _lista[tipo] = listado;
        setLista(_lista);
    }

    const criterios = (opc, ccampo) => {
        setTitulo(omodel?.model[ccampo]?.header);
        setTipo(opc);
        setDialogCriterio(true);
    }

    return (
        <>
            <Panel headerTemplate={headerTemplate}>
                <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                    {table({ action01: accionesTbl, reg: setItem, items: itemsMenu() })}
                </div>
            </Panel>

            <Dialog visible={dialogActor} header={customDialogHeader} modal className="p-fluid dialog-personalizado" onHide={() => {
                setDialogActor(false);
            }}
                style={{ width: '400px' }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="formgrid grid">
                        {inDrop('actor_interno', lista?.MTR_RIESGO_ACTOR_INTERNO, { lab: 'nombre' }, 11)}
                        <div className="field col-1" style={{ display: 'flex', flexDirection: 'column', marginTop: '1.85rem' }}>
                            <Button icon="pi pi-search-plus" rounded severity="info" type="button" tooltip="Añadir actores internos"
                                onClick={() => criterios('MTR_RIESGO_ACTOR_INTERNO', 'actor_interno')} />
                        </div>

                        {inDrop('actor_externo', lista?.MTR_RIESGO_ACTOR_EXTERNO, { lab: 'nombre' }, 11)}
                        <div className="field col-1" style={{ display: 'flex', flexDirection: 'column', marginTop: '1.85rem' }}>
                            <Button icon="pi pi-search-plus" rounded severity="info" type="button" tooltip="Añadir actores externos"
                                onClick={() => criterios('MTR_RIESGO_ACTOR_EXTERNO', 'actor_externo')} />
                        </div>
                    </div>
                    {generic.buttonsForms(setDialogActor, load)}
                </form>
            </Dialog>

            <Dialog visible={dialogCriterio} header={titulo} modal className="p-fluid dialog-personalizado" onHide={() => {
                setDialogCriterio(false);
            }}
                style={{ maxWidth: '500px' }}>
                <Criterios toast={toast} permss={permss} generic={generic} riesgo={riesgo} tipo={tipo} seleccion={seleccion} seleccionar={false} listar="solo" funcionalidades={funcionalidades} />
            </Dialog>
        </>
    )
}
